import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Processing } from '../../cmg-1003/models/processing.model';
import { Cmg1003ProcessingStore } from './processing.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003ProcessingQuery extends Query<Processing> {
  protected store: Cmg1003ProcessingStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(Cmg1003ProcessingStore);

    super(store);

    this.store = store;
  }
}
